import { render, staticRenderFns } from "./link-row.vue?vue&type=template&id=2f54e92c&"
import script from "./link-row.vue?vue&type=script&lang=ts&"
export * from "./link-row.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports